import React, { useState } from 'react';
import { Alert, Button, Card } from 'react-bootstrap';
import SignaturePad from '../../../pages/m4/predioPrograma/signaturePad';
import { CursosService } from '../../../../service/cursos.service';

const DECLARACION =
  'Declaro que he respondido este cuestionario de manera consciente, honesta y con pleno conocimiento ' +
  'de su propósito, asumiendo la responsabilidad por la veracidad de la información proporcionada.';

interface CursoFirmaFinalProps {
  cursoId: string;
  onFirmado: () => void;
}

export default function CursoFirmaFinal({ cursoId, onFirmado }: CursoFirmaFinalProps) {
  const [firma, setFirma] = useState('');
  const [enviando, setEnviando] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleFirmar = async () => {
    if (!firma) {
      setError('Debe dibujar su firma antes de continuar');
      return;
    }
    setEnviando(true);
    setError(null);
    try {
      await CursosService.firmar(cursoId, { firma });
      onFirmado();
    } catch (e: any) {
      setError(e?.response?.data?.message ?? 'No se pudo registrar la firma. Intente nuevamente.');
    } finally {
      setEnviando(false);
    }
  };

  return (
    <Card>
      <Card.Header>Declaración final</Card.Header>
      <Card.Body>
        <p>{DECLARACION}</p>
        <SignaturePad onChange={setFirma} />
        {error && (
          <Alert variant="danger" className="mt-3">
            {error}
          </Alert>
        )}
        <div className="d-flex justify-content-end mt-3">
          <Button variant="success" onClick={handleFirmar} disabled={enviando}>
            {enviando ? 'Guardando...' : 'Firmar y finalizar curso'}
          </Button>
        </div>
      </Card.Body>
    </Card>
  );
}
